module.exports = __webpack_public_path__ + "img/四川省中医医院.bd1319ac.png";